<template>
    <div class="editReservationPopupBg d-flex flex-column align-items-center justify-content-center" @click.self="handleBackgroundClick">
        <div class="popupArea bg-lightest py-3 px-4">

            <div class="text-center fs-larger font-weight-600 pb-2 dark-top">
                Invoice Details
            </div>

            <div class="form-group row mb-0">
                <div class="col-sm-12">
                    <h5 class="d-flex justify-content-between align-items-center">
                        <span>PROFILE</span>
                        <div v-if="false" class="d-flex justify-content-right align-items-center position-relative">
                            <loader></loader>
                        </div>
                        <div v-else class="d-flex justify-content-right align-items-center position-relative">
                            <button class="btn blue mr-2" 
                                    :disabled="getIsSendingInvoiceToMailLoading" 
                                    @click="sendInvoice(selectedInvoice)">Send</button>
                            
                            <button class="btn blue mr-2" 
                                    :disabled="getIsPrintingInvoice || getIsCancellingInvoice" 
                                    @click="printInvoiceClicked(selectedInvoice.id)">Print</button>
                           
                            <three-dots 
                                v-if="listActions.length > 0 && selectedInvoice.type.id != 1 && !getIsPrintingInvoice && !getIsCancellingInvoice && selectedInvoice.isActive && selectedInvoice.bookingInvoiceLinkedId === null" 
                                @input="selectedConnectionAction" 
                                :items="listActions"
                                :isLighter="true"
                                :divClass="'color-6'">
                            </three-dots>
                        </div>
                    </h5>
                </div>
            </div>
            
            <div class="form-group row">
                <div class="col-sm-6">
                    <label class="full">
                        Document Type
                        <input type="text" :value="selectedInvoice.type.label" disabled>
                    </label>
                </div>

                <div class="col-sm-6">
                    <label class="full">
                        Number
                        <input type="text" :value="selectedInvoice.code" disabled>
                    </label>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-6">
                    <label class="full">
                        Date
                        <input type="text" :value="formatDateDots(selectedInvoice.date)" disabled>
                    </label>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-6">
                    <label class="full">
                        Client
                        <input type="text" :value="selectedInvoice.name" disabled>
                    </label>
                </div>

                <div class="col-sm-6">
                    <label class="full">
                        VAT Number
                        <input type="text" :value="selectedInvoice.vatNr" disabled>
                    </label>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-6">
                    <label class="full">
                        Amount
                        <input type="text" :value="formatPrice(selectedInvoice.value) + ' €'" disabled>
                    </label>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-6">
                    <label class="full">
                        Linked to
                        <input type="text" :value="`${selectedInvoice.bookingRelationsQuantity} Booking${selectedInvoice.bookingRelationsQuantity > 1 ? 's':''}`" disabled>
                        <div class="pointer mt-1">
                            <span class="color-1" @click="expandBookings">View list</span>
                        </div>
                    </label>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-12">
                    <div class="invoiceBookingsHolder darker bold d-flex flex-column" v-if="invoiceBookingsArr.length > 0">
                        <div class="invoiceLabel dark bold">Linked to</div>
                        <div>
                            <div v-for="bookingRow in invoiceBookingsArr" @click.stop="openInvoiceBooking(bookingRow)" class="pointer"><span class="color-1">{{formatTicketNumber(bookingRow.sequencialNumber)}}</span> - {{bookingRow.event.product.name}}</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12">
                    <div class="invoiceBookingsHolder darker bold d-flex flex-column" v-if="selectedInvoice.url != null">
                        <div class="invoiceLabel dark bold">External Link</div>
                        <div>
                            <div class="pointer dark bold"><a class="color-1" target="_blank" :href="selectedInvoice.url">link</a></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Buttons -->
            <div class="d-flex w-100 justify-content-end mb-2">
                <button class="btn tertiary mr-3" @click="closeSubModal">Close</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import threeDots from '@/tools/threeDots';
// mixins
import { invoicesMixin } from '@/mixins/invoices';

export default {
    data: function() {
        return {
            invoiceBookingsArr: []
        }
    },
    mixins: [
        invoicesMixin
    ],
    props:{
        reservation: {
            type: Object,
            default: null
        },
        invoice: {
            type: Object,
            default: null
        }
    },
    beforeDestroy: function() {
        this.eventHub.$off('closeInvoiceCreditNoteReason');
        this.eventHub.$off('closeSendInvoiceToMail');
    },
    computed: {
        ...mapGetters([
            'getSelectedInvoice',
            'getIsCancellingInvoice',
            'getIsPrintingInvoice',
            'getIsSendingInvoiceToMailLoading',
            'account',
        ]),
        selectedInvoice: function() {
            return this.normalizeInvoice(this.getSelectedInvoice);
        },
        listActions: function () {
            let self = this;
            const invoice = this.selectedInvoice;

            let action_print = {
                label: 'Credit Note',
                toolTip: 'This will emit a credit note',
                action: function () {
                    self.openModal('InvoiceCancellation');

                    self.eventHub.$on('closeInvoiceCreditNoteReason', chargebackReason => {
                        self.$dialog.confirm('This action will generate a corresponding Credit Note. Are you sure you want to cancel this invoice?').then(() => {
                            self.cancelInvoice({
                                invoice: invoice,
                                booking: this.reservation || {id: null},
                                chargebackReason: chargebackReason
                            }).then(response => {
                                if (response.status === 200) {
                                    //Set it as inactive
                                    self.getSelectedInvoice.isActive = false;
                                    if (self.reservation) self.reservation.bookingInvoices.push(response.data);

                                    // Save reservation
                                    self.updateExistingReservation({
                                        supplierId: self.account.supplierId,
                                        reservation: self.reservation
                                    }).then(response => {
                                        if (response.status && response.status == 200) {
                                            self.reservation.updateFlags = {};
                                            self.eventHub.$emit('updateThisReservation', response.data);
                                        }
                                    })
                                }
                                
                                self.toggleModal();
                            })
                        })
                        .catch(function () {})
                    })              
                }
            }

            let actionsArray = [action_print];

            return actionsArray;
        }
    },
    methods: {
        ...mapActions([
            'cancelInvoice',
            'printInvoice',
            'getBookingsFromInvoice',
            'openModal',
            'sendInvoiceToMail',
            'updateExistingReservation',
        ]),
        handleBackgroundClick(event) {
            const selectedText = window.getSelection().toString();
            if (selectedText.length > 0) {
                return;
            } else {
                this.closeSubModal();
            }
        },
        selectedConnectionAction: function (item) {
            item.action();
        },
        closeSubModal: function() {
            this.$emit('toggleInvoiceModal', 'close');
        },
        printInvoiceClicked: function (invoiceId) {
            this.printInvoice(invoiceId).then(response => {
                if (response.status == 200) {
                    this.openByteArrayNewTab(response.data);
                }
            }).catch(err => { })
        },
        sendInvoice: function (invoice) {
            this.openModal('SendInvoice');

            this.eventHub.$on('closeSendInvoiceToMail', () => {
                this.sendInvoiceToMail({invoiceId: invoice.id, email: invoice.email});
            })
        },
        expandBookings: function () {
            this.getBookingsFromInvoice({
                bookingInvoiceId: this.getSelectedInvoice.id
            }).then(bookingsArr => {
                this.invoiceBookingsArr = bookingsArr;
            })
        },
        openInvoiceBooking: function (booking) {
            window.open('/reservations/view/'+booking.sequencialNumber, '_blank');
        },
        pressDone: function() {
            this.toggleModal();
        },
        toggleModal: function () {
            this.$emit('toggleInvoiceModal', this.selectedSeller);
        }
    },
    components: {
        threeDots,
    }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .editReservationPopupBg {
        background-color: rgba(0,0,0,0.5);
        width: 100%;
        height: 100%;
        z-index: 20 !important;
        position: absolute;

        .popupArea {
            width: 620px;
            max-height: 100%;
            max-width: 100%;
            margin: 0 auto;

            .invoiceBookingsHolder {
                max-height: 300px;
                overflow-y: auto;
            }
        }
    }

    .invoiceLabel {
        width: 100px;
    }
</style>



// WEBPACK FOOTER //
// InvoiceModal.vue?208e52d4